/*
  "Buy More Save More" — mỗi món một dòng hàng riêng, dùng ô của chính Customily.

  Ô cho từng món do OPTION SET của Customily lo (18/09/2026): option set sinh từ
  template nhiều món có option ẩn "Layout" (giá trị "1 PC", "2 PCS"…, function
  layoutVisibility) và các ô "Custom Your Name #2", "#3"… chỉ hiện ở layout đủ
  món. Theme KHÔNG tự nhân bản ô nhập nữa — bản cũ (17/09) chép khối option #1
  thành #2, #3… đã bỏ theo yêu cầu.

  Theme còn hai việc:

  1. Đổi Layout theo số lượng. Chọn 3 PCS trong bảng bậc → Layout = "3 PCS" →
     preview của Customily vẽ 3 bông, hiện ô tên #2, #3.

  2. Bấm mua thì TÁCH thành từng dòng, mỗi dòng 1 món:
         Layout về "1 PC" (file in phải là 1 bông, không phải cả bộ)
         → điền tên/font của món N vào ô chính (#1)
         → bấm nút mua của Customily (app tự sinh file in + gọi /cart/add)
         → chờ /cart/add rồi làm món kế tiếp
     Ô "#N" để trống thì lấy theo #1; các món giống hệt gộp một dòng.
     Discount tag `bmsm` đếm tổng số món qua nhiều dòng nên giá vẫn đúng bậc.

  Sản phẩm không có option Layout / ô "#N" thì chạy như Customily thường:
  N món cùng một thiết kế, một dòng quantity N.

  ĐÃ ĐO TRÊN LIVE (17/09/2026):
  - Đổi giá trị ô Customily bằng code rồi bấm mua lần hai: ra production-url và
    personalization-id MỚI — app không giữ bản cũ.
  - Mỗi lần Customily sinh file mất ~7 giây, nên chạy tuần tự và báo tiến độ.
  - Bỏ trống ô bắt buộc: app KHÔNG gọi /cart/add và bật chữ "Required".
*/
(function () {
  if (window.__voDesignsLoaded) return;
  window.__voDesignsLoaded = true;

  var ADD_PATH = /\/cart\/add(\.js)?(\?|$)/;
  var CUSTOMILY_BUTTON = '#customily-cart-btn, .customily-cart-btn';
  var STICKY_BUTTON = '.sticky-add-to-cart button';
  var CONTROL = 'input[name^="properties["], select[name^="properties["], textarea[name^="properties["]';
  var POLL_MS = 1500;
  /* Customily sinh file ~7s trên máy nhanh; mobile chậm có thể gấp mấy lần. */
  var START_TIMEOUT = 60000;
  var RESPONSE_TIMEOUT = 30000;
  /* Customily báo "Required" gần như ngay (đo < 1,3s). */
  var VALIDATION_WINDOW = 2500;

  var running = false;

  /* ---------- Bắt /cart/add ---------- */

  var waiters = [];

  function notify(kind, payload) {
    waiters.slice().forEach(function (w) {
      w(kind, payload);
    });
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var promise = nativeFetch.apply(this, arguments);
      if (!ADD_PATH.test(String(url)) || !waiters.length) return promise;

      notify('start');
      promise.then(
        function (response) {
          try {
            response
              .clone()
              .json()
              .then(
                function (data) {
                  /* Lỗi của Shopify vẫn trả JSON, nhận ra bằng trường `status`. */
                  if (!response.ok || (data && data.status)) notify('error', data && (data.description || data.message));
                  else notify('ok', data);
                },
                function () {
                  notify(response.ok ? 'ok' : 'error', null);
                }
              );
          } catch (e) {
            notify(response.ok ? 'ok' : 'error', null);
          }
        },
        function () {
          notify('error', null);
        }
      );
      return promise;
    };
  }

  /* ---------- Đọc / ghi form Customily ---------- */

  /*
    Customily (Vue) ẩn option bằng `v-show`, tức style inline `display: none`.
    Đọc thuộc tính style chứ KHÔNG gọi getComputedStyle: bản đầu gọi 16 lần mỗi
    nhịp, mà mỗi lần có thể ép trình duyệt tính lại style cả trang.
  */
  function isShown(el) {
    return !el.closest('[style*="display: none"], [style*="display:none"]');
  }

  function keyOf(control) {
    return control.name.slice('properties['.length, -1);
  }

  function kindOf(control) {
    if (control.tagName === 'SELECT') return 'select';
    if (control.tagName === 'TEXTAREA') return 'text';
    if (control.type === 'radio') return 'radio';
    if (control.type === 'text') return 'text';
    return null;
  }

  /* Nhãn sạch: bỏ dấu *, chữ "Required", bộ đếm "(0|12)" của app. */
  function cleanLabel(option, fallback) {
    var nameEl = option.querySelector('.option_name');
    if (!nameEl) return fallback;
    var copy = nameEl.cloneNode(true);
    [].slice.call(copy.querySelectorAll('.customily-required-label, .maxlength-counter')).forEach(function (n) {
      n.remove();
    });
    return copy.textContent.replace(/\s+/g, ' ').trim() || fallback;
  }

  /*
    Các option Customily đang hiện, theo đúng thứ tự trên trang. Tra lại mỗi
    lần: Customily có thể dựng lại form, node cũ là node chết.
  */
  function customilyOptions() {
    return scanOptions().base;
  }

  /*
    TEMPLATE NHIỀU MÓN CỦA CUSTOMILY (vd hướng dương 2 bông, 18/09/2026).

    Option set sinh từ template có layout nhiều món thì Customily tự có ô cho
    món #2: "Custom Your Name #2", "Custom Your Name #2 Font"… (hiện khi option
    ẩn Layout = "2 PCS"). Những ô đó là của món #2 — lúc mua, món #2 lấy giá
    trị từ chính chúng.

    Nhận ra bằng nhãn: có cụm " #N" (N >= 2). Bỏ cụm đó ra là tên ô gốc:
    "Custom Your Name #2 Font" → "Custom Your Name Font".
  */
  var SLOT = / #(\d+)(?=\s|$)/;

  function scanOptions() {
    var app = document.getElementById('cl_optionsapp');
    var out = { base: [], slots: {}, nativeMax: 1 };
    if (!app) return out;

    [].slice.call(app.querySelectorAll('.customily_option')).forEach(function (option) {
      if (!isShown(option)) return;
      var control = option.querySelector(CONTROL);
      if (!control) return;
      var kind = kindOf(control);
      if (!kind) return;
      var key = keyOf(control);
      var opt = { key: key, kind: kind, option: option, label: cleanLabel(option, key) };
      var m = key.match(SLOT);
      if (m && +m[1] >= 2) {
        var n = +m[1];
        (out.slots[n] || (out.slots[n] = {}))[key.replace(SLOT, '')] = opt;
        if (n > out.nativeMax) out.nativeMax = n;
      } else {
        out.base.push(opt);
      }
    });
    return out;
  }

  /*
    Đổi option Layout của Customily theo số lượng.

    Option này ẩn khỏi khách nên KHÔNG có control trong DOM — phải đi qua
    component Vue "CustomilyOptions" của app: gán `value` rồi gọi
    `optionChange(option, setId, null, false, true)`, đúng như app tự làm khi
    một điều kiện chọn giá trị (selectValueByCondition). Truyền set.id, không
    truyền cả object set — sai là engine bật CẢ HAI layout một lúc.

    Nhận ra option bằng function `layoutVisibility`, không bằng nhãn. Giá trị
    đọc số ở đầu: "1 PC", "2 PCS" → lấy giá trị lớn nhất không vượt số lượng.
  */
  function customilyComponent() {
    var app = document.getElementById('cl_optionsapp');
    var vm = app && app.__vue__;
    if (!vm) return null;
    var hit = null;
    (function walk(v, d) {
      if (!v || hit || d > 25) return;
      if (typeof v.optionChange === 'function' && v.engraverStateManager) {
        hit = v;
        return;
      }
      (v.$children || []).forEach(function (c) {
        walk(c, d + 1);
      });
    })(vm.$root, 0);
    return hit;
  }

  function layoutOption() {
    var comp = customilyComponent();
    if (!comp) return null;
    var sm = comp.engraverStateManager;
    var sets = (sm.deps && typeof sm.deps.getSets === 'function' && sm.deps.getSets()) || comp.sets || [];
    for (var i = 0; i < sets.length; i++) {
      var opts = sets[i].options || [];
      for (var j = 0; j < opts.length; j++) {
        var fns = opts[j].functions || [];
        /* Chỉ nhận option Layout bị ẩn khỏi khách. Option layout khách tự chọn
           ("Gingerbread" 1–7, "Number of Marshmallows", "7 Grandchildren") cũng
           bắt đầu bằng số nhưng là số người, không phải số món — đụng vào là
           chọn 2 PCS biến 5 bánh gừng thành 2 (19/10/2026). */
        if (opts[j].hide_visually && fns.some(function (f) { return f.type === 'layoutVisibility'; }) && (opts[j].values || []).length) {
          return { comp: comp, set: sets[i], option: opts[j] };
        }
      }
    }
    return null;
  }

  /*
    Số lượng VƯỢT số món lớn nhất mà template có (vd template tới 6 bông, khách
    chọn 8 hay 10): quay về layout nhỏ nhất (1 món) chứ không giữ layout 6 —
    preview 6 bông cho đơn 8 cái là hứa sai. Ô "#2"… gắn điều kiện theo layout
    nên cũng ẩn theo → mọi món dùng chung tên #1; hiện dòng ghi chú báo khách.
  */
  function setLayoutForQty(qty) {
    var lo = layoutOption();
    if (!lo) return false;
    var best = null;
    var bestN = 0;
    var minN = Infinity;
    var minVal = null;
    var maxN = 0;
    lo.option.values.forEach(function (v) {
      var n = parseInt(v.value, 10);
      if (!n) return;
      if (n < minN) {
        minN = n;
        minVal = v.value;
      }
      if (n > maxN) maxN = n;
      if (n <= qty && n > bestN) {
        bestN = n;
        best = v.value;
      }
    });
    if (qty > maxN || (sameName && qty >= 2)) best = minVal;
    showOverLimitNote(qty > maxN && maxN > 1 ? maxN : 0);
    showSameNameToggle(qty >= 2 && qty <= maxN && maxN > 1 ? qty : 0);
    if (!best || lo.option.value === best) return false;
    lo.comp.$set(lo.option, 'value', best);
    lo.comp.optionChange(lo.option, lo.set.id, null, false, true);
    return true;
  }

  /*
    CHỌN "DIFFERENT NAMES" / "SAME NAME" (19/09/2026).

    Mặc định "Different names" (user chốt 19/09) = mỗi món một thiết kế: Layout theo số
    lượng, hiện ô #2…#N, mỗi món một dòng giỏ.
    "Same name" = mọi món cùng một thiết kế: giữ Layout ở "1 PC" dù số lượng bao
    nhiêu → preview 1 bông, ô "#2"… ẩn theo điều kiện của Customily, khách chỉ
    nhập 1 tên. Bấm mua thì hasOwnDesigns() không thấy ô "#N" nào đang hiện →
    Customily mua thường: 1 dòng, quantity N.
    Đổi sang "Same name" KHÔNG đổi số lượng (user chốt 19/09). Lựa chọn được nhớ khi đổi bậc.
  */
  var sameName = false;

  /*
    Khối chọn nằm ngay dưới bảng bậc Buy More Save More (chọn số lượng xong là
    chọn luôn kiểu thiết kế); trang không có bảng bậc thì đặt ở đầu khung
    Customily. Horizon có thể morph lại section khi đổi size → node mất, nên
    render() gọi lại hàm này với `toggleQty` đã nhớ.

    Hai thẻ nút (cùng kiểu thẻ bậc) thay cho checkbox: user thấy checkbox trơn
    "Different Designs" khó hiểu (19/09). Nút type=button, không name → không
    lọt vào form.
  */
  var toggleQty = 0;

  function showSameNameToggle(qty) {
    toggleQty = qty;
    var box = document.querySelector('.vo-designs__same');
    if (!qty) {
      if (box) box.hidden = true;
      return;
    }
    var tiers = document.querySelector('.volume-offer .volume-offer__tiers');
    var panel = document.querySelector('#cl_optionsapp .customily_sets-panel');
    if (!tiers && !panel) return;
    if (!box) {
      box = document.createElement('div');
      box.className = 'vo-designs__same';
      box.setAttribute('role', 'group');
      box.innerHTML =
        '<p class="vo-designs__same-title"></p>' +
        '<div class="vo-designs__same-options">' +
        '<button type="button" class="vo-designs__same-option" data-mode="different">' +
        '<span class="vo-designs__same-dot" aria-hidden="true"></span>' +
        '<span class="vo-designs__same-text"><strong>Different names</strong><small>A unique name for each item</small></span>' +
        '</button>' +
        '<button type="button" class="vo-designs__same-option" data-mode="same">' +
        '<span class="vo-designs__same-dot" aria-hidden="true"></span>' +
        '<span class="vo-designs__same-text"><strong>Same name</strong><small></small></span>' +
        '</button>' +
        '</div>';
      box.addEventListener('click', function (event) {
        var btn = event.target.closest('.vo-designs__same-option');
        if (!btn) return;
        var next = btn.getAttribute('data-mode') === 'same';
        if (next === sameName) return;
        sameName = next;
        render();
      });
    }
    if (tiers) {
      if (tiers.nextElementSibling !== box) tiers.insertAdjacentElement('afterend', box);
    } else if (panel.firstChild !== box) {
      panel.insertBefore(box, panel.firstChild);
    }
    box.hidden = false;
    [].slice.call(box.querySelectorAll('.vo-designs__same-option')).forEach(function (btn) {
      var on = (btn.getAttribute('data-mode') === 'same') === sameName;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var title = 'Personalize your ' + qty + ' items';
    var titleEl = box.querySelector('.vo-designs__same-title');
    if (titleEl.textContent !== title) titleEl.textContent = title;
    var hint = 'One name on all ' + qty;
    var hintEl = box.querySelector('[data-mode="same"] small');
    if (hintEl.textContent !== hint) hintEl.textContent = hint;
  }

  function showOverLimitNote(maxN) {
    var panel = document.querySelector('#cl_optionsapp .customily_sets-panel');
    if (!panel) return;
    var note = panel.querySelector(':scope > .vo-designs__note');
    if (!maxN) {
      if (note) note.remove();
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'vo-designs__note';
      panel.insertBefore(note, panel.firstChild);
    }
    var text = 'Separate names are available for up to ' + maxN + ' items. For larger quantities, every item uses the same name and font.';
    if (note.textContent !== text) note.textContent = text;
  }

  /*
    Customily dựng app muộn (27-31s trên mobile chậm) — chưa có component thì
    để nguyên layoutKey, nhịp poll sau thử lại. Có component mà không có option
    Layout (sản phẩm thường) thì coi như xong, khỏi dò lại cây Vue mỗi nhịp.
  */
  var layoutKey = '1';
  function syncLayout(qty) {
    var key = qty + (sameName ? '|same' : '');
    if (key === layoutKey) return;
    if (!customilyComponent()) return;
    layoutKey = key;
    setLayoutForQty(qty);
  }

  function controlsOf(opt) {
    return [].slice.call(opt.option.querySelectorAll(CONTROL)).filter(function (c) {
      return keyOf(c) === opt.key;
    });
  }

  function readValue(opt) {
    var controls = controlsOf(opt);
    if (opt.kind === 'radio') {
      var checked = controls.filter(function (c) {
        return c.checked;
      })[0];
      return checked ? checked.value : '';
    }
    return controls[0] ? controls[0].value : '';
  }

  var inputSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  var areaSetter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
  var selectSetter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;

  /* Customily là Vue — gán `.value` thôi thì state của app không đổi, phải bắn event. */
  function writeValue(opt, value) {
    var controls = controlsOf(opt);
    if (!controls.length) return;

    if (opt.kind === 'radio') {
      var target = controls.filter(function (c) {
        return c.value === value;
      })[0];
      /* click() tự đặt checked và bắn input/change như khách bấm thật. */
      if (target && !target.checked) target.click();
      return;
    }

    var control = controls[0];
    if (control.value === value) return;
    var setter = control.tagName === 'SELECT' ? selectSetter : control.tagName === 'TEXTAREA' ? areaSetter : inputSetter;
    setter.call(control, value);
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function requiredErrorShown() {
    return [].slice
      .call(document.querySelectorAll('#cl_optionsapp .customily-required-label > span'))
      .some(function (el) {
        return el.style.display !== 'none' && el.offsetParent !== null;
      });
  }

  /* ---------- Số lượng ---------- */

  function quantityInput() {
    var el = document.querySelector('quantity-selector-component input[type="number"]');
    return el && el.isConnected ? el : null;
  }

  function currentQty() {
    var input = quantityInput();
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  /* Cùng cách volume-offer.js đặt số lượng — đi qua API của component. */
  function setQty(qty) {
    var input = quantityInput();
    if (!input) return;
    var host = input.closest('quantity-selector-component');
    if (host && typeof host.setValue === 'function') {
      host.setValue(String(qty));
      if (typeof host.onQuantityChange === 'function') host.onQuantityChange();
      if (typeof host.updateButtonStates === 'function') host.updateButtonStates();
    } else {
      inputSetter.call(input, String(qty));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* ---------- Trạng thái + vẽ theo số lượng ---------- */

  /*
    Dòng báo tiến độ "Adding 1 of 3 to cart…" — nằm cuối form Customily, ngay
    trên nút mua. Tạo lúc cần; Vue không gỡ node lạ gắn vào panel (đo 17/09).
  */
  function statusEl() {
    var panel = document.querySelector('#cl_optionsapp .customily_sets-panel');
    if (!panel) return null;
    var status = panel.querySelector(':scope > .vo-designs__status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'vo-designs__status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      panel.appendChild(status);
    }
    return status;
  }

  function render() {
    if (running) return;
    syncLayout(currentQty());
    if (toggleQty && !document.querySelector('.vo-designs__same')) showSameNameToggle(toggleQty);
  }

  function setStatus(text, isError) {
    var status = text ? statusEl() : document.querySelector('#cl_optionsapp .vo-designs__status');
    if (!status) return;
    status.textContent = text || '';
    status.classList.toggle('vo-designs__status--error', !!isError);
  }

  /* ---------- Chia thành dòng hàng ---------- */

  function ownValue(itemIndex, key, slots) {
    var native = slots && slots[itemIndex + 2] && slots[itemIndex + 2][key];
    var v = native ? readValue(native) : '';
    return typeof v === 'string' ? v.trim() : '';
  }

  /*
    Mỗi món = bộ giá trị đầy đủ (trống thì lấy của #1). Món trùng nhau gộp thành
    một dòng — cả N món giống hệt thì trả về một nhóm duy nhất.
  */
  function buildGroups(options, qty, slots) {
    var first = {};
    options.forEach(function (opt) {
      first[opt.key] = readValue(opt);
    });

    var groups = [];
    var byKey = {};

    for (var i = 0; i < qty; i++) {
      var values = {};
      options.forEach(function (opt) {
        values[opt.key] = (i > 0 && ownValue(i - 1, opt.key, slots)) || first[opt.key];
      });
      var key = JSON.stringify(values);
      if (byKey[key]) {
        byKey[key].count++;
      } else {
        byKey[key] = { values: values, count: 1 };
        groups.push(byKey[key]);
      }
    }
    return { groups: groups, first: first };
  }

  /* ---------- Chạy lần lượt ---------- */

  /*
    Nhường một nhịp cho Vue cập nhật state — KHÔNG dùng setTimeout.

    Khách hay chuyển tab trong lúc chờ. Tab ẩn thì Chrome dồn timer: đo trên tab
    nền, `setTimeout(400)` mất 12 giây, cả vòng 2 món kéo dài hơn một phút.
    MessageChannel không bị dồn như vậy, mà Vue chỉ cần vài microtask là xong.
  */
  function yieldTask() {
    return new Promise(function (resolve) {
      var channel = new MessageChannel();
      channel.port1.onmessage = function () {
        resolve();
      };
      channel.port2.postMessage(null);
    });
  }

  function settle() {
    return yieldTask().then(yieldTask).then(yieldTask);
  }

  /*
    Bấm nút Customily một lần và chờ kết quả.

    Ba kết cục: 'ok' (đã vào giỏ), 'invalid' (Customily chặn vì thiếu ô bắt
    buộc — không có request nào), 'error' (request lỗi hoặc quá hạn).
  */
  function addOnce(button) {
    return new Promise(function (resolve) {
      var started = false;
      var done = false;
      var timers = [];

      function finish(result, detail) {
        if (done) return;
        done = true;
        timers.forEach(clearTimeout);
        var at = waiters.indexOf(onEvent);
        if (at !== -1) waiters.splice(at, 1);
        resolve({ result: result, detail: detail });
      }

      function onEvent(kind, payload) {
        if (kind === 'start') {
          started = true;
          timers.push(setTimeout(function () {
            finish('error', null);
          }, RESPONSE_TIMEOUT));
        } else if (kind === 'ok') {
          finish('ok', payload);
        } else if (kind === 'error') {
          finish('error', payload);
        }
      }

      waiters.push(onEvent);

      timers.push(setTimeout(function () {
        if (!started && requiredErrorShown()) finish('invalid', null);
      }, VALIDATION_WINDOW));
      timers.push(setTimeout(function () {
        if (!started) finish(requiredErrorShown() ? 'invalid' : 'error', null);
      }, START_TIMEOUT));

      button.click();
    });
  }

  function applyValues(values) {
    customilyOptions().forEach(function (opt) {
      if (opt.key in values && values[opt.key] !== '') writeValue(opt, values[opt.key]);
    });
  }

  function run(button) {
    var qty = currentQty();
    var scan = scanOptions();
    var plan = buildGroups(scan.base, qty, scan.slots);
    var nativeSnapshot = [];
    Object.keys(scan.slots).forEach(function (n) {
      Object.keys(scan.slots[n]).forEach(function (base) {
        var opt = scan.slots[n][base];
        nativeSnapshot.push({ key: opt.key, value: readValue(opt) });
      });
    });
    var groups = plan.groups;
    var original = plan.first;

    running = true;

    var added = 0;
    var lastItem = null;
    window.clAtcHold = true;

    /*
      Mỗi dòng giỏ là MỘT món → file in phải là layout 1 món. Để layout nhiều
      món thì Customily sinh file có cả 2 bông cho từng dòng. Ô "#2" gốc bị ẩn
      theo điều kiện của app nên không lọt vào property của dòng hàng.
    */
    var layoutChanged = setLayoutForQty(1);

    var chain = layoutChanged ? settle() : Promise.resolve();

    groups.forEach(function (group, index) {
      chain = chain.then(function (stop) {
        if (stop) return stop;

        setStatus('Adding ' + (added + 1) + (group.count > 1 ? '–' + (added + group.count) : '') + ' of ' + qty + ' to cart…');

        applyValues(group.values);
        setQty(group.count);

        /* Cho Vue kịp nhận giá trị mới trước khi app đọc state để sinh file. */
        return settle()
          .then(function () {
            return addOnce(button);
          })
          .then(function (outcome) {
            if (outcome.result === 'ok') {
              added += group.count;
              lastItem = outcome.detail;
              return null;
            }
            if (outcome.result === 'invalid' && index === 0) return 'invalid';
            return outcome.detail || 'error';
          });
      });
    });

    return chain.then(function (stop) {
      applyValues(original);
      setQty(qty);
      layoutKey = null;
      syncLayout(qty);
      /* Ô "#2" gốc hiện lại sau khi trả layout — ghi lại thứ khách đã nhập. */
      settle().then(function () {
        var slotNow = scanOptions().slots;
        nativeSnapshot.forEach(function (item) {
          Object.keys(slotNow).forEach(function (n) {
            Object.keys(slotNow[n]).forEach(function (base) {
              var opt = slotNow[n][base];
              if (opt.key === item.key && item.value) writeValue(opt, item.value);
            });
          });
        });
      });
      window.clAtcHold = false;
      running = false;

      if (!stop) {
        setStatus('');
        render();
        if (lastItem && typeof window.clAtcShow === 'function') window.clAtcShow(lastItem, qty);
        return;
      }

      if (stop === 'invalid') {
        /* Customily đã tự bật "Required" ở ô thiếu — không nói gì thêm. */
        setStatus('');
        return;
      }

      if (added && lastItem && typeof window.clAtcShow === 'function') window.clAtcShow(lastItem, added);
      setStatus(
        added
          ? 'Added ' + added + ' of ' + qty + ' items. Something went wrong with the rest — please try again.'
          : typeof stop === 'string' && stop !== 'error'
          ? stop
          : 'Could not add to cart. Please try again.',
        true
      );
    });
  }

  /* ---------- Chặn nút mua ---------- */

  function hasOwnDesigns() {
    var qty = currentQty();
    if (qty >= 2) {
      var slots = scanOptions().slots;
      for (var n in slots) {
        for (var base in slots[n]) {
          if (+n <= qty && readValue(slots[n][base]).trim()) return true;
        }
      }
    }
    return false;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      var target = event.target.closest(CUSTOMILY_BUTTON + ', ' + STICKY_BUTTON);
      if (!target) return;

      /* Cú bấm do chính mình phát ra trong vòng lặp — cho đi. */
      if (running && !event.isTrusted) return;

      if (running) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      render();
      if (!hasOwnDesigns()) return;

      var button = document.querySelector(CUSTOMILY_BUTTON);
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      run(button);
    },
    true
  );

  /*
    VẼ THEO SỰ KIỆN, POLL CHỈ LÀ LƯỚI AN TOÀN.

    - Bấm bậc / nút +/-: component số lượng bắn `quantity-selector:update`
      (bubbles) — volume-offer.js cũng đi qua `onQuantityChange()` nên bắn luôn.
    - Gõ chữ / chọn swatch / chọn dropdown ở #1, hoặc gõ tay ô số lượng: `input`
      và `change`.
    Poll 1,5s để đỡ những lúc không có sự kiện nào: Customily dựng form muộn,
    Horizon morph section khi đổi size. Ở 1 PC mỗi nhịp chỉ đọc một ô số lượng.
  */
  function onPageInput(event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (t.closest('#cl_optionsapp, quantity-selector-component')) render();
  }

  document.addEventListener('quantity-selector:update', render);
  document.addEventListener('input', onPageInput, true);
  document.addEventListener('change', onPageInput, true);
  setInterval(function () {
    if (!document.hidden) render();
  }, POLL_MS);
})();
